var $35da740d59af89ba$exports = {};
document.addEventListener("DOMContentLoaded", ()=>{
    try {
        const animatedElements = document.querySelectorAll("[data-animate]");
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && entry.target instanceof Element) {
                    const animation = entry.target.dataset.animate;
                    entry.target.classList.add("animate__animated", `animate__${animation}`);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            root: null,
            threshold: 0.1
        });
        animatedElements.forEach((el)=>{
            observer.observe(el);
        });
    } catch (error) {
        console.log(`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{441} \u{430}\u{43D}\u{438}\u{43C}\u{430}\u{446}\u{438}\u{44F}\u{43C}\u{438}: ${error}`);
    }
});


//# sourceMappingURL=Vantage.09aa1015.js.map
